import {Component, inject} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../../../../../shared/helper/dialog-helper';
import {PlayerMessage} from '../../../../../model/player-message';
import {Divider} from 'primeng/divider';
import {Button} from 'primeng/button';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-player-profile-message-detail',
  imports: [
    Divider,
    Button,
    DatePipe,
    TranslatePipe
  ],
  templateUrl: './player-profile-message-detail.component.html',
  styleUrl: './player-profile-message-detail.component.scss'
})
export class PlayerProfileMessageDetailComponent
{
  private config = inject(DynamicDialogConfig);

  message: PlayerMessage;

  public static showDialog(dialogService: DialogService, message: PlayerMessage, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileMessageDetailComponent,
      DialogHelper.createBasicConfig(
        {
          header: translate.instant('MESSAGE'),
          width: DialogHelper.getDialogWidth(1000),
          data: {message}
        }));
  }

  constructor()
  {
    this.message = this.config.data.message;
  }

  public openLink(link: string): void
  {
    if (link)
      window.open(link, '_blank');
  }
}
